<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '活动策划')[0].value">
      <div style="width: 80%;height: 95%;" v-if="EventPlanningShow">
        <div  style="display: flex;">
          <div>
            <el-button type="primary"
                  :disabled="isdisabled"
                  @click="AIClick">AI助手</el-button>
        <el-button type="primary"
                
                  :disabled="isdisabled"
                  @click="eventClick">策划</el-button>
          </div>
        </div>
        <div>
          <h5 style="margin: 5px; color: red;font-size: 14px">点击AI助手，可利用AIGC（生成式人工智能）技术自动生成活动文案方案。</h5>
        </div>
        <el-table :data="
              SModelEventPlanningList.slice(
                (currentPage - 1) * pagesize,
                currentPage * pagesize)"
                  style="width: 100%;height: 80%"
                  empty-text="暂无数据"
                  v-loading="loding">
          <el-table-column prop="copywriting"
                          label="活动文案"
                          align="center">
          </el-table-column>
          <el-table-column label="操作" width="150%">
            <template #default="scope">
              <el-button type="primary"
                        @click="edit(scope.$index, scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChangeType"
                      @current-change="handleCurrentChangeType"
                      :current-page="currentPage"
                      :page-sizes="[5, 10, 15, 20]"
                      :page-size="pagesize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="SModelEventPlanningList.length"
                      style="display: flex; justify-content: center;margin-top: 10px;">
        </el-pagination>
      </div>
      <AIGenerateCard v-if="AIGenerateCardView" :AICardtransfer="AItransfer"></AIGenerateCard>
    </ShowControl>
</template>
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
import AIGenerateCard from "../../Card/AIGenerate/AIGenerateCard.vue"
export default {
  props: ["department"],
  data () {
    return {
      shangchuan: true,
      loding: false,
      isdisabled: false,
      caseID: localStorage.getItem("caseId"),
      flowID: localStorage.getItem("flowID"),
      EventPlanningList: [],
      fileList: [],
      SModelEventPlanningList: [],
      activityNumber: 0,
      currentPage: 1,
      pagesize: 10,
      activity: {},
      eventForm: {
        copywriting: '',
      },
      title: '活动策划',
      rules: {
        copywriting: [{ required: true, message: "请输入活动文案", trigger: "blur" },],
      },
      AIGenerateCardView:false,
      EventPlanningShow:true,
      AItransfer:{
        },
        AIID:0,
        AI:{},
        typedText: ''
    };
  },
  components: {ShowControl,AIGenerateCard},
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  created () {
    this.GetSModelEventPlanning();
    this.GetSModelExhibitionPlanning();
  },
  mounted(){
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      if(this.EventPlanningShow == true){
        this.$router.push("/ExhibitionServices")
      }else{
        this.GetSModelEventPlanning();
        this.EventPlanningShow = true
        this.AIGenerateCardView =false
      }
    },
    AIClick(){
      if (this.flowID != this.Global.FlowList.策划) {
        this.$message.error("当前流程阶段不是策划，无法进行操作！");
        return;
      }
      this.EventPlanningShow = false
      this.GetAI()
    },
    edit () {
      this.$router.push({path:'EventPlanningEditCard',query:{ state : 'edit' }})
    },
    handleSizeChangeType: function (size) {
      this.pagesize = size;
    },
    //当前页码
    handleCurrentChangeType: function (currentPage) {
      this.currentPage = currentPage;
    },
    eventClick () {
      this.$router.push("/EventPlanningEditCard")
    },
    GetSModelEventPlanning () {
      this.$http
        .get(
          "SModel/GetTypeSModel?round=" +
          this.Round +
          "&typename=S_Activity"
        )
        .then((res) => {
          if (res.success) {
            this.SModelEventPlanningList = res.dynamicObj;
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetSModelExhibitionPlanning () {
      this.$http
        .get(
          "SModel/GetTypeSModel?round=" +
          this.Round +
          "&typename=S_ExhibitionPlanning"
        )
        .then((res) => {
          if (res.success) {
            let ExhibitionPlanning = res.dynamicObj;
            if (ExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete).length > 0 && ExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete)[0].activityID != null && ExhibitionPlanning.filter(c => c.state != this.Global.SModel.Delete)[0].isactivity) {
              this.activityNumber = 1;
              this.isdisabled = false;
            } else {
              this.isdisabled = true;
            }
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    GetAI(){
      this.AI={}
      this.$http.get(`StudentData/GetAI?Round=${this.Round}&Type=${this.Global.AiEnum.活动文案}&ParentID=0`).then((res)=>{
        if (res.success) {
          this.AI = res.dynamicObj
          if (this.AI===null) {
            this.GetPlanningData()
          } else {
            this.AIID = res.dynamicObj.id
            this.typedText= res.dynamicObj.answer
            this.GetPlanningData()
          }
        } else {
            this.ischat = false;
          return this.$message.warning(res.message)
        }
      })
    
    },
    GetPlanningData () {
      this.$http
        .get(
          "StudentData/GetMeadiaData?round=" + this.Round
        )
        .then((res) => {
          if (res.success) {
            let data = res.dynamicObj;
            var copywriting = `会展名称：海丝博览会；会展主题：${data.themes}；目标市场：${data.targetMarket}；会展场馆：${data.exhibitionVenue}；活动名称：${data.activityName}`
            this.generate(copywriting)
          } else {
            return this.$message.error(res.message);
          }
        });
    },
    generate(copywriting){
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.Global.chaturl + `api/Chat/ChatTeampleMsg?teampid=${this.Global.chatTemplateID.活动文案}`);
      xhr.setRequestHeader('Content-Type', 'text/event-stream');
      xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
            if(xhr.responseText=="")
            {
              this.$message.warning("AI生成失败，请联系管理员！");
              return;
            }
            // 避免接受过程中缺少字符
            const responseData=  xhr.responseText.replace(/\s+/g, '').trim();
            this.template=decodeURIComponent(JSON.parse(responseData).data).replace("{}",copywriting);
            this.AItransfer ={
              problem:this.template,
              type:this.Global.AiEnum.活动文案,
              answer:this.typedText,
              parentID: 0,
              id:this.AI===null?0:this.AIID
            }
            this.$refs.showControl.receiveValue(true);
            this.AIGenerateCardView =true
          }
        }
      }
      xhr.send();
    },
  },
};
  </script>
  
  <style scoped>
</style>